import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Fee, FeeChartModel } from '../models/fee.chart.model';
import { Currency } from '../models/currency.model';

@Injectable({
  providedIn: 'root'
})
export class FeeService {
  constructor(private http: HttpService) {}

  getFeeHistory(start: string, finish: string, userId: number): Observable<any> {
    const timeZoneOffset = new Date().getTimezoneOffset() * -1;
    const url = userId
      ? `/v1/admin/order/fee/${userId}?start_at=${start}&finish_at=${finish}&timezone_offset=${timeZoneOffset}`
      : `/v1/admin/order/fee?start_at=${start}&finish_at=${finish}&timezone_offset=${timeZoneOffset}`;
    return this.http.request('get', url).pipe(
      map((response: any) => response.data),
      map((data: any) =>
        data.map((chart: any) => {
          const feechart = new FeeChartModel();
          feechart.currency = new Currency(chart.currency);
          feechart.fees = chart.fees.map((eachFee: any) => new Fee(eachFee));
          return feechart;
        })
      )
    );
  }
}
